import React from 'react'
import { displayedEnvironmentName } from '../../utils/EnvironmentHelper'

// local / integration / staging のときだけ環境名を表示する。
export default class EnvironmentLabel extends React.Component {
  render() {
    const environmentName = displayedEnvironmentName()
    if (!environmentName) return null

    return (
      <div className={`c-EnvironmentLabel is-${environmentName}`}>
        {environmentName.toUpperCase()}
      </div>
    )
  }
}
